import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

const ScalableImg = ({ alt, src, className, scale = 2 }) => {
  const formattedSrc = useMemo(
    () => (src ? src.replace('%s', `${scale}`) : ''),
    [src, scale],
  );
  return <img alt={alt} src={formattedSrc} className={className} />;
};

ScalableImg.defaultProps = {
  alt: '',
  className: '',
  scale: 2,
};

ScalableImg.propTypes = {
  alt: PropTypes.string,
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
  scale: PropTypes.number,
};

export default ScalableImg;
